
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.45 15A1 1 0 0012 15l-3.5 3.56a2.21 2.21 0 01-3.06 0 2.15 2.15 0 010-3.06L9 12a1 1 0 10-1.41-1.41L4 14.08A4.186 4.186 0 109.92 20l3.53-3.53a1 1 0 000-1.47zm7.75-8a4.16 4.16 0 00-7.12-3l-3.53 3.56A1.02 1.02 0 1012 9l3.5-3.56a2.21 2.21 0 013.06 0 2.15 2.15 0 010 3.06L15 12a1 1 0 000 1.41 1 1 0 001.41 0L20 9.92A4.19 4.19 0 0021.2 7z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M19.5 13.45l1.76.47.02-.07a1.008 1.008 0 01-.26 2h-.26L19 15.38a1 1 0 11.5-1.93zM15.205 18.65a1 1 0 01.175.35l.51 1.79a1 1 0 01-.71 1.23c-.086.01-.174.01-.26 0a1 1 0 01-1-.74l-.47-1.76a1 1 0 011.755-.87zM18.131 17.19a1 1 0 01.689.24l1.29 1.29a1 1 0 010 1.41 1 1 0 01-1.41 0l-1.29-1.29a1 1 0 01.721-1.65zM5.505 10.39c-.212.162-.48.234-.745.2a.778.778 0 01-.26-.04l-1.76-.47a1 1 0 11.52-1.93l1.76.44a1.008 1.008 0 01.485 1.8zM8.99 5.544A1 1 0 018.62 5l-.44-1.72a1 1 0 111.93-.52l.47 1.76a1 1 0 01-.7 1.22.82.82 0 01-.26 0 1 1 0 01-.63-.196zM5.88 6.88a1 1 0 01-.7-.29L3.89 5.3A1 1 0 015.3 3.89l1.29 1.29a1 1 0 010 1.41 1 1 0 01-.71.29z","fill":"#ED4A68"}})])
          )
        }
      }
    